
export default {
  name: 'CardIcon',
  props: {
    cardIcon: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasDescription() {
      return Boolean(this.cardIcon.description && this.cardIcon.description.length > 0)
    },
  },
}
